import { $host } from './index';

export const getSummaryReport = async () => {
  const {data} = await $host.get('web/reports/summary');
  return data;
}

export const guestedCount = async (inputValue, startDate, endDate) => {
  const { data } = await $host.get(
    `web/reports/guestedCount/?phone=${inputValue}&startDate=${startDate}&endDate=${endDate}`
  );
  return data;
};

export const getPatients = async () => {
  const { data } = await $host.get(`web/reports/patients`);
  return data;
};
export const getPatientRefferals = async () => {
  const { data } = await $host.get(`web/reports/reffinfo`);
  return data;
};

export const getAdminsInfo = async () => {
  const { data } = await $host.get(`web/reports/admins`);
  return data;
};

export const getAdminReferralsInfo = async (adminId) => {
  const { data } = await $host.post(`web/reports/adminreferralsinfo`, { id: adminId });
  return data;
};

export const updateRewardStatusAPI = async (rewardId, status) => {
  const { data } = await $host.post(`web/reports/updateone`, { id: rewardId, status });
  return data;
};

export const updateBulkRewardStatusAPI = async (selectedIds, status) => {
  const { data } = await $host.post(`web/reports/updatesome`, { ids: selectedIds, status });
  return data;
};
